import React from "react";
import { Col, Row, Form } from "react-bootstrap";

import { HookFormRadioButton } from "components";

type StatusRowProps = {
	register: any;
	title?: string;
};

const StatusRow = ({ register, title }: StatusRowProps) => (
	<>
		<Form.Label>
			Do you want to change the residuals status of the {title} to
			‘withhold residuals’?
		</Form.Label>
		<Row>
			<Col sm={3}>
				<HookFormRadioButton
					value="true"
					name="is_status_update"
					label="Yes"
					id="yesStatusUpdate"
					register={register}
				/>
			</Col>
			<Col>
				<HookFormRadioButton
					value="false"
					name="is_status_update"
					label="No"
					id="noStatusUpdate"
					register={register}
				/>
			</Col>
		</Row>
	</>
);

export default StatusRow;
